// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.note-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.note-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

/* START: Updated header styles */
.note-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
}
.note-header .note-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

/* END: Updated header styles */
.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  /* margin-right: 1.5rem; // Removed */
  text-transform: uppercase;
}

.note-title h2 {
  margin: 0;
  font-size: 1.3rem;
  color: var(--text-dark);
  font-weight: 600;
}

/* START: Added client-actions styles */
.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* END: Added client-actions styles */
.note-tag {
  display: inline-block;
  margin-top: 0.5rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
}

.note-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.detail-item .icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.detail-item label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-light);
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.detail-item p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
}

.detail-item.any-desc {
  margin-top: 1rem;
}
.detail-item.any-desc > div {
  width: 100%;
}
.detail-item.any-desc div {
  font-size: 0.95rem;
  color: var(--text-dark);
  line-height: 1.4rem;
}

.note-document a {
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: underline;
}
.note-document a:hover {
  text-decoration: none;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

.error-message {
  text-align: center;
  color: var(--danger-color);
  font-weight: 500;
  font-size: 1rem;
  padding: 2rem;
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .note-detail-container {
    padding: 1rem;
  }
  .note-card {
    padding: 1.5rem;
  }
  .note-details-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewNote/ViewNote.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA,iCAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAEA,+BAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;AAAF;;AAIE;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AADJ;;AAKA,uCAAA;AACA;EACE,aAAA;EACA,YAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAFJ;AAII;EACE,yCAAA;EACA,2BAAA;AAFN;AAKM;EACE,YAAA;EACA,2BAAA;AAHR;AAOI;EACE,wCAAA;EACA,0BAAA;AALN;AAOM;EACE,YAAA;EACA,2BAAA;AALR;;AAUA,qCAAA;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AARF;;AAWA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,qBAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AARF;AAUE;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAWE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AATJ;AAYE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAVJ;;AAcA;EACE,gBAAA;AAXF;AAaE;EACE,WAAA;AAXJ;AAcE;EACE,kBAAA;EACA,uBAAA;EAEA,mBAAA;AAbJ;;AAkBE;EACE,gBAAA;EACA,2BAAA;EACA,0BAAA;AAfJ;AAgBI;EACE,qBAAA;AAdN;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAhBF;;AAmBA;EACE;IACE,yBAAA;EAhBF;AACF;AAmBA;EACE;IACE,aAAA;EAjBF;EAoBA;IACE,eAAA;EAlBF;EAqBA;IACE,0BAAA;EAnBF;AACF","sourcesContent":[":root {\r\n  --primary-light: #eef2ff;\r\n  --success-color: #10b981;\r\n  --danger-color: #ef4444;\r\n  --text-dark: #1f2937;\r\n  --text-medium: #4b5563;\r\n  --text-light: #9ca3af;\r\n  --bg-light: #f9fafb;\r\n  --card-bg: #ffffff;\r\n  --border-radius: 12px;\r\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n  --transition: all 0.3s ease;\r\n}\r\n\r\n.note-detail-container {\r\n  padding: 1rem;\r\n  background-color: #f4f6f8;\r\n  display: flex;\r\n}\r\n\r\n.note-card {\r\n  background-color: var(--card-bg);\r\n  border-radius: var(--border-radius-primary);\r\n  box-shadow: var(--box-shadow);\r\n  width: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n/* START: Updated header styles */\r\n.note-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  margin-bottom: 2rem;\r\n  border-bottom: 1px solid #eee;\r\n  padding-bottom: 1.5rem;\r\n\r\n  .note-header-data {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n  }\r\n}\r\n/* END: Updated header styles */\r\n\r\n.avatar {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.75rem;\r\n  font-weight: bold;\r\n  /* margin-right: 1.5rem; // Removed */\r\n  text-transform: uppercase;\r\n}\r\n\r\n.note-title {\r\n  h2 {\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    color: var(--text-dark);\r\n    font-weight: 600;\r\n  }\r\n}\r\n\r\n/* START: Added client-actions styles */\r\n.client-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  \r\n  button {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    transition: all 0.2s;\r\n    \r\n    &.btn-update {\r\n      background-color: var(--primary-light-bg);\r\n      color: var(--primary-color);\r\n      // border: 1px solid var(--primary-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n    \r\n    &.btn-delete {\r\n      background-color: var(--danger-light-bg);\r\n      color: var(--danger-color);\r\n      \r\n      &:hover {\r\n        opacity: 0.9;\r\n        transform: translateY(-1px);\r\n      }\r\n    }\r\n  }\r\n}\r\n/* END: Added client-actions styles */\r\n\r\n.note-tag {\r\n  display: inline-block;\r\n  margin-top: 0.5rem;\r\n  background-color: var(--primary-light);\r\n  color: var(--primary-color);\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.note-details-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 0.8rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.detail-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n\r\n  .icon {\r\n    font-size: 1.25rem;\r\n    color: var(--primary-color);\r\n    margin-top: 0.25rem;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  label {\r\n    display: block;\r\n    font-size: 0.75rem;\r\n    text-transform: uppercase;\r\n    color: var(--text-light);\r\n    letter-spacing: 0.5px;\r\n    margin-bottom: 0.25rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0;\r\n    font-size: 0.95rem;\r\n    font-weight: 500;\r\n    color: var(--text-dark);\r\n  }\r\n}\r\n\r\n.detail-item.any-desc {\r\n  margin-top: 1rem;\r\n  \r\n  > div {\r\n    width: 100%;\r\n  }\r\n  \r\n  div {\r\n    font-size: 0.95rem;\r\n    color: var(--text-dark);\r\n    // font-weight: 500;\r\n    line-height: 1.4rem;\r\n  }\r\n}\r\n\r\n.note-document {\r\n  a {\r\n    font-weight: 500;\r\n    color: var(--primary-color);\r\n    text-decoration: underline;\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid rgba(67, 97, 238, 0.2);\r\n  border-top-color: var(--primary-color);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 2rem auto;\r\n}\r\n\r\n.error-message {\r\n  text-align: center;\r\n  color: var(--danger-color);\r\n  font-weight: 500;\r\n  font-size: 1rem;\r\n  padding: 2rem;\r\n  width: 100%;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .note-detail-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .note-card {\r\n    padding: 1.5rem;\r\n  }\r\n\r\n  .note-details-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
